import { useDispatch } from 'react-redux';

import { TDispatch } from 'shared/mf-infrastructure/types/redux';

export const useAppDispatch: () => TDispatch = useDispatch;
